import React, {useCallback, useEffect, useState} from 'react';
import {useDispatch, useSelector} from "react-redux";
import {Link, useNavigate} from "react-router-dom";
import {debounce} from "lodash";
import MindsetsJsSDK, {
    SetUserAction,
    LoadMeAction,
    actions,
    toastActions,
    countriesConstants,
    statesConstants,
    DistrictDropdown,
    ErrorMessageAction,
    SuccessMessageAction,
    LoadingAction,
    filterConstants,
    LoadSchoolsAction,
    SchoolDropdownItem,
    LoadedSchoolsAction,
    LoadedSchoolsTotalAction,
    StateField
} from "mindsets-js-sdk";
import useAuth from "../../hooks/useAuth";

import './profile_school.scss';

export default function () {
    useAuth(['teacher']);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const me = useSelector(state => state.me);
    const user = useSelector(state => state.user);
    const schools = useSelector(state => state.schools);
    const schools_total = useSelector(state => state.schools_total);
    const [submitting, setSubmitting] = useState(false);
    const [country, setCountry] = useState('');
    const [state, setState] = useState('');
    const [districtId, setDistrictId] = useState(null);
    const [name, setName] = useState('');
    const [requested, setRequested] = useState(false);
    const [requestedPartial, setRequestedPartial] = useState(false);
    let user_new = JSON.parse(JSON.stringify(user));

    useEffect(() => {
        if (!!me) {
            if (!user) {
                dispatch(SetUserAction(me));
            }
            if (me.school) {
                let country = '';
                let state = '';
                if (me.school.district) {
                    if (me.school.district.country) {
                        country = me.school.district.country;
                    }
                    if (me.school.district.state) {
                        state = me.school.district.state;
                    }
                }
                if (!country && me.school.country) {
                    country = me.school.country;
                }
                if (!state && me.school.state) {
                    state = me.school.state;
                }
                setCountry(country);
                setState(state);
            }
        }
    }, [me]);

    const debounced = useCallback(debounce(a => a(), 600), []);

    function onSave() {
        if (user_new.school_id && user_new.school_id !== me.school_id) {
            if (!submitting) {
                Promise.resolve()
                    .then(() => setSubmitting(true))
                    .then(() => dispatch(LoadingAction(true, 'Saving your school')))
                    .then(() => MindsetsJsSDK().API.patch(`me/school`, {school_id: user_new.school_id}))
                    .then(() => setSubmitting(false))
                    .then(() => dispatch(LoadingAction(false)))
                    .then(() => dispatch(LoadMeAction()))
                    .then(() => {
                        if (me.school_id || me.persona === 'student') {
                            navigate(-1);
                        } else {
                            navigate('/profile/update');
                        }
                    })
                    .catch(error => {
                        console.error(error);
                        dispatch(actions.LoadingAction(false));
                        dispatch(toastActions.ErrorMessageAction('We could not successfully save your data. Please try again.'));
                        setSubmitting(false);
                    });
            }
        } else {
            if (!user_new.school_id) {
                dispatch(ErrorMessageAction('Please choose the school'));
            } else if (user_new.school_id === me.school_id) {
                dispatch(SuccessMessageAction('You have already joined this school'));
            }
        }
    }

    function onSearch() {
        const options = {
            q: name,
            'filters[country][0]': filterConstants.EXPRESSION_EQUAL + '=' + country,
            'selectors[0]': 'district'
        };
        if (Object.keys(statesConstants.STATES).includes(country) && state) {
            options['filters[state][0]'] = filterConstants.EXPRESSION_EQUAL + '=' + state
        }
        if (countriesConstants.COUNTRIES_WITH_DISTRICTS.includes(country) && districtId) {
            options['filters[district_id][0]'] = filterConstants.EXPRESSION_EQUAL + '=' + districtId
        }
        Promise.resolve()
            .then(() => dispatch(LoadingAction(true, 'Searching full match')))
            .then(() => setRequested(false))
            .then(() => setRequestedPartial(false))
            .then(() => dispatch(LoadSchoolsAction(options)))
            .then(() => dispatch(LoadingAction(false)))
            .then(() => setRequested(true))
            .catch(error => {
                dispatch(ErrorMessageAction('Something went wrong. Please try again.'));
                console.error(error);
                dispatch(LoadingAction(false));
                setRequested(false);
            });
    }

    function onPartialMatchSearch() {
        const data = {name, country};
        if (Object.keys(statesConstants.STATES).includes(country) && state) {
            data.state = state
        }
        if (countriesConstants.COUNTRIES_WITH_DISTRICTS.includes(country) && districtId) {
            data.district_id = districtId
        }
        Promise.resolve()
            .then(() => dispatch(LoadingAction(true, 'Searching partial match')))
            .then(() => setRequested(false))
            .then(() => setRequestedPartial(false))
            .then(() => MindsetsJsSDK().API.post('schools/find', data))
            .then(response => {
                dispatch(LoadedSchoolsAction(response.schools))
                dispatch(LoadedSchoolsTotalAction(response.schools.length))
            })
            .then(() => dispatch(LoadingAction(false)))
            .then(() => setRequested(true))
            .then(() => setRequestedPartial(true))
            .catch(error => {
                dispatch(ErrorMessageAction('Something went wrong. Please try again.'));
                console.error(error);
                dispatch(LoadingAction(false));
                setRequested(false);
            });
    }

    function renderCancel() {
        return (
            <button onClick={event => {
                event.preventDefault();
                if (me.school_id) {
                    navigate(-1);
                } else {
                    dispatch(ErrorMessageAction('Please choose your school'))
                }
            }} className="btn btn-flat">Cancel
            </button>
        );
    }

    function renderSaveButton() {
        return (
            <button
                onClick={event => {
                    event.preventDefault();
                    onSave();
                }}
                className={"btn " + (user_new.school_id && user_new.school_id !== me.school_id ? "btn-dark" : "btn-grey")}>Save
            </button>
        );
    }

    function renderDistrictField() {
        if (country && countriesConstants.COUNTRIES_WITH_DISTRICTS.includes(country)) {
            if (state || !Object.keys(statesConstants.STATES).includes(country)) {
                return (
                    <div className="col s12 m4">
                        <DistrictDropdown
                            onSelect={district => {
                                if (district) {
                                    setDistrictId(district.id);

                                    return district.name;
                                } else {
                                    return '';
                                }
                            }}
                            id='profile-school-district'
                            label={'School District(optional)'}
                            country={country}
                            state={state ? state : null}
                            debounce={debounced}
                            with_reset={true}
                            onReset={() => setDistrictId(null)}
                        />
                    </div>
                );
            }
        }

        return null;
    }

    function renderSchoolNameField() {
        if (country) {
            if (state || !Object.keys(statesConstants.STATES).includes(country)) {
                return (
                    <div className="col s12">
                        <div className="flex-row flex-gap-20 flex-v-end">
                            <div className='flex-grow-1'>
                                <label>Your School's name</label>
                                <input
                                    type='text'
                                    value={name}
                                    onChange={event => setName(event.target.value)}
                                />
                            </div>
                            <div>
                                <button
                                    className='btn btn-dark btn-form'
                                    disabled={!name}
                                    onClick={onSearch}
                                >Search
                                </button>
                            </div>
                        </div>
                    </div>
                );
            }
        }

        return null;
    }

    function renderTooManySuggestion() {
        if (schools_total > 25) {
            let suggestion = 'Seems like there are too many matches. Try narrowing down the list by providing full name of the school';
            if (!districtId && country && countriesConstants.COUNTRIES_WITH_DISTRICTS.includes(country)) {
                suggestion += ' or selecting a School District';
            }

            return <div>{suggestion}.</div>;
        }

        return null;
    }

    function renderToFewSuggestion() {
        if (requested && schools.length > 0 && schools.length <= 3) {
            return (
                <div>
                    <span>Seems like there are too few matches. </span>
                    <span>{schools.length === 1 ? 'If it\'s not your school' : 'If you can\'t find your school in the list'}, try a shorter school name</span>
                    {districtId ?
                        <span> or check whether you picked the right School District in the filter above</span> : null}
                    <span>, or try </span>
                    <a href='!#' onClick={event => {
                        event.preventDefault();
                        onPartialMatchSearch();
                    }}>partial match search</a>
                    <span>.</span>
                </div>
            );
        }

        return null;
    }

    function renderNoneSuggestion() {
        if (requested && schools.length <= 0) {
            return (
                <div>
                    <span>No schools found. Please check your filters. </span>
                    <span>Try a shorter school name</span>
                    {districtId ?
                        <span> or check whether you picked the right School District in the filter above</span> : null}
                    <span>, or try </span>
                    <a href='!#' onClick={event => {
                        event.preventDefault();
                        onPartialMatchSearch();
                    }}>partial match search</a>
                    <span>.</span>
                </div>
            );
        }

        return null;
    }

    function renderAddSchoolSuggestion() {
        if (requestedPartial) {
            return (
                <div>
                    <span>Still can't find your school? </span>
                    <span>Just </span>
                    <Link to='/profile/school/add'>add it</Link>
                    <span>.</span>
                </div>
            );
        }

        return null;
    }

    function renderCurrentSchool() {
        if (me.school_id && me.school) {
            return (
                <div>
                    <div className='section'>
                        <h3 className='header-new'>My school</h3>
                        <SchoolDropdownItem item={me.school}/>
                    </div>
                    <hr/>
                </div>
            );
        }

        return null;
    }

    if (!user) {
        return null;
    }

    return (
        <div className="container" id='profile-school-update'>
            {renderCurrentSchool()}

            <div className='section'>
                <h2 className="header-new">Find Your School</h2>

                <div className="profile-school-info section">
                    <div className="row">
                        <div className="col s12 m4">
                            <label>Country</label>
                            <select
                                value={country}
                                onChange={event => setCountry(event.target.value)}
                            >
                                <option value='' disabled={true}>Please select a country</option>
                                {Object.keys(countriesConstants.COUNTRIES).map(code => {
                                    return (
                                        <option key={code} value={code}>{countriesConstants.COUNTRIES[code]}</option>
                                    );
                                })}
                            </select>
                        </div>

                        <StateField onChange={setState} country={country} value={state} outer_class_name='col s12 m4'/>
                        {renderDistrictField()}
                    </div>
                    <div className="row">{renderSchoolNameField()}</div>
                </div>

                <div className='my-3'>
                    {renderNoneSuggestion()}
                    <div>
                        {schools.length > 0 ? 'We have found ' + schools_total + ' school' + (schools_total !== 1 ? 's' : '') + ' matching your request. ' + (schools_total > schools.length ? schools.length + ' displayed.' : '') : null}
                    </div>
                    {renderTooManySuggestion()}
                    {renderToFewSuggestion()}
                    {renderAddSchoolSuggestion()}
                </div>
                <div className='school-list flex-row flex-wrap flex-gap-20'>
                    {schools.map(school => {
                        return (
                            <div
                                key={school.id}
                                className={'school-list-item ' + (school.id === user_new.school_id ? 'selected' : '')}
                                onClick={() => {
                                    if (user_new.school_id === school.id) {
                                        user_new.school_id = null;
                                        delete user_new.school;
                                    } else {
                                        user_new.school_id = school.id;
                                        user_new.school = school;
                                    }
                                    dispatch(SetUserAction(user_new));
                                }}>
                                <SchoolDropdownItem item={school}/>
                            </div>
                        );
                    })}
                </div>

                <div className="flex-row flex-v-center h100 flex-h-end flex-gap-10">
                    {renderCancel()}
                    {renderSaveButton()}
                </div>
            </div>
        </div>
    );
};
